// extracted by mini-css-extract-plugin
module.exports = {"container":"Statistics_container__16Faq","inner-container":"Statistics_inner-container__1XgnV","alert":"Statistics_alert__29BAV"};